import React from "react";
import { normalizePixRow, validatePixRow } from "../../utils/pix";

export default function RampsPrecheckModal({
  open,
  onCancel,
  onContinue,
  rows = [],
}) {
  if (!open) return null;

  const normalized = rows.map(normalizePixRow);
  const totalUsdt = normalized.reduce((a, r) => a + (Number(r.amount) || 0), 0);

  const errors = normalized
    .map((r, i) => ({ i, errs: validatePixRow(r) }))
    .filter(({ errs }) => errs.length > 0)
    .slice(0, 3);

  return (
    <div className="precheck-backdrop">
      <div className="precheck-modal">
        <h3 style={{ marginTop: 0 }}>Atenção</h3>
        <p style={{ marginBottom: 8 }}>
          <b>Por favor, valide os dados que foram preenchidos</b> antes de
          confirmar o envio.
        </p>
        <ul style={{ marginTop: 0 }}>
          <li>Confira as chaves Pix, nomes e documentos.</li>
          <li>Confirme os valores digitados (USDT → BRL na etapa seguinte).</li>
          <li>Se estiver tudo certo, continue para a confirmação.</li>
        </ul>

        <div style={{ margin: "12px 0", opacity: 0.85 }}>
          <div>
            Destinatários: <b>{rows.length}</b>
          </div>
          <div>
            Total a enviar (USDT): <b>{totalUsdt.toFixed(2)}</b>
          </div>
        </div>

        {errors.length > 0 && (
          <div
            style={{
              background: "rgba(255, 99, 71, 0.1)",
              border: "1px solid rgba(255, 99, 71, 0.3)",
              padding: 10,
              borderRadius: 8,
              marginBottom: 12,
            }}
          >
            <b>Observações nas primeiras linhas:</b>
            <ul style={{ marginTop: 6 }}>
              {errors.map(({ i, errs }) => (
                <li key={i}>
                  Linha {i + 1}: {errs.join(", ")}
                </li>
              ))}
            </ul>
          </div>
        )}

        <div className="precheck-actions">
          <button className="btn" onClick={onCancel}>
            Voltar
          </button>
          <button className="btn btn--primary" onClick={onContinue}>
            Continuar
          </button>
        </div>
      </div>

      <style>{`
        .precheck-backdrop {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,.55);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
        }
        .precheck-modal {
          width: min(560px, 92vw);
          background: #151a2b;
          color: #e9edf5;
          border: 1px solid #21283d;
          border-radius: 16px;
          box-shadow: 0 10px 30px rgba(0,0,0,.35);
          padding: 18px;
        }
      `}</style>
    </div>
  );
}

